import { Text } from '@chakra-ui/react';

// The figure's size, its code's size, and how far the code is raised so its
// top lines up with the digits'.
const SIZES = {
  lg: { fontSize: '34px', lineHeight: '40px', code: '12px', raise: '15px' },
  md: { fontSize: '22px', lineHeight: '28px', code: '10px', raise: '8px' },
  // The Accounts summary card's pair of figures, Copilot's size there.
  card: { fontSize: '19px', lineHeight: '24px', code: '10px', raise: '6px' },
  sm: { fontSize: '17px', lineHeight: '22px', code: '9px', raise: '6px' },
};

/**
 * A lead figure with its currency code small and raised before it
 * ("COP 4,812,300"), so the number carries the weight. It formats nothing:
 * `amount` arrives formatted, without its code.
 */
export default function Figure({ code, amount, size = 'lg', color = 'redesign.heading', ...props }) {
  const s = SIZES[size] || SIZES.lg;
  return (
    <Text
      as="span"
      textStyle="figure"
      fontSize={s.fontSize}
      lineHeight={s.lineHeight}
      color={color}
      whiteSpace="nowrap"
      {...props}
    >
      {code && (
        <Text as="span" textStyle="figureCode" fontSize={s.code} verticalAlign={s.raise} mr="0.25em">
          {code}
        </Text>
      )}
      {amount}
    </Text>
  );
}
